import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Navigation} from './navigation.service';
import {CookieService} from 'ng2-cookies';
import {user} from '../models/user';
import {Subject} from "rxjs";
import {ProyectoService} from "./proyecto.service";
import {DeviceService} from "./device.service";
import {HttpClientService} from "./http-client.service";
import {ERROR_LICENSE, Roles} from '../commons/util';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private logged: boolean = false;
  private loginError = new Subject();
  private user: user = undefined;

  constructor(private http: HttpClientService, private navigation: Navigation,
              private cookieService: CookieService, private proyectoService: ProyectoService,
              private deviceService: DeviceService) {

    this.loginError.next(0);

    if (cookieService.check("session")) {
      if (cookieService.get("session") == "open") {
        this.loginByToken(cookieService.get("token"));
      } else {
        cookieService.set("session", "close");
        cookieService.set("token", "");
      }
    } else {
      cookieService.set("session", "close");
      cookieService.set("token", "");
    }

  }

  public logIn(email: string, password: string) {

    this.loginError.next(0);

    let json =
      {
        "email": email,
        "password": password
      };

      this.http.post('/user/login', JSON.stringify(json)).subscribe(result => {
        this.loginError.next(1);
        this.user = <user>JSON.parse(result);
        this.logged = true;
        this.cookieService.set("session", "open");
        this.cookieService.set("token", this.user["token"]);
        this.setProjectCookieUser();
        this.navigation.toHome();
      }, error => {
        console.log(error);
        if(error.error == ERROR_LICENSE) {
          this.loginError.next(-2);
        } else {
          this.loginError.next(-1);
        }

        this.logOut();
      });

  }

  public getLoginError() {
    return this.loginError;
  }

  public new(usuario: user) {
    return this.http.post('/user/new', usuario);
  }

  public rechargeUser() {
    if (this.logged) {
      this.loginByToken(this.cookieService.get("token"));
    }
  }

  async loginByToken(token: string) {
    let params = new HttpParams().set("token",token);
    await this.http.getWithParams('/user/getbytoken', params).toPromise().then(result => {
      this.user = <user>result;
      this.logged = true;
      this.cookieService.set("session", "open");
      this.cookieService.set("token", result["token"]);
      this.setProjectCookieUser();
    }, error => {
      this.logOut();
    });
  }

  setProjectCookieUser() {
    if (!this.user.proyectos || this.user.proyectos.length === 0) {
      this.cookieService.delete("project");
      return;
    }

    let project = undefined;

    if (this.user.idProyectoSeleccionado) {
      project = this.user.proyectos.find(
        proyecto => proyecto.idProyecto == this.user.idProyectoSeleccionado);
    }

    if (!project) {
      project = this.user.proyectos[0];
    }
    
    this.proyectoService.setProyectoActual(project);
  }

  getByIdEmpresa(idEmpresa: string) {
    let params = new HttpParams().set("idEmpresa",idEmpresa);
    return this.http.getWithParams('/user/getbyidempresa', params);
  }

  public logOut() {
    this.user = null;
    this.logged = false;
    this.deviceService.nothingSelect();
    this.cookieService.set("session", "close");
    this.cookieService.set("token", "");
    this.navigation.toLogin();
  }

  public async isLogged() {
    if (!this.logged) {
      if (this.cookieService.get("session") == "open") {
        await this.loginByToken(this.cookieService.get("token"));
      } else {
        return false;
      }
    }
    return true;
  }

  public getId() {
    return this.user.idUsuario;
  }

  public getName() {
    if (this.user == undefined) {
      return "";
    }
    return this.user.nombre + " " + this.user.apellidos;
  }

  public getNombre() {
    return this.user.nombre;
  }

  public getApellidos() {
    return this.user.apellidos;
  }

  public getEmail() {
    return this.user.email;
  }

  public getTelefono() {
    return this.user.telefono;
  }

  public getEmpresa() {
    return this.user.idEmpresa;
  }

  public getPermiso() {
    if (this.user == undefined) {
      return "";
    }
    return this.user.idPermiso;
  }

  public getIdContacto() {
    return this.user.idContacto;
  }

  public getProyectos() {
    return this.user.proyectos;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user: user) {
    this.user = user;
  }

  public changePermiso(idUsuario: string, idPermiso: string) {

    let json =
      {
        "idUsuario": idUsuario,
        "idPermiso": idPermiso
      };

    this.http.patch('/user/changeidpermiso', JSON.stringify(json)).subscribe(result => {
      console.log(result);
    });

  }

  public changeProyecto(idUsuario: string, idProyecto: string, check: boolean) {

    let json =
      {
        "idUsuario": idUsuario,
        "idProyecto": idProyecto,
        "check": check
      };

    this.http.patch('/user/changeproyecto', JSON.stringify(json)).subscribe(result => {
      console.log(result);
    });

  }

  public updateUser(nombre, apellidos, email, telefono) {

    this.user.nombre = nombre;
    this.user.apellidos = apellidos;
    this.user.email = email;
    this.user.telefono = telefono;

    return this.http.patch('/user/updateUser', this.user);

  }

  public updatePassword(oldPassword: string, newPassword: string) {

    let json =
      {
        "idUsuario": this.getId(),
        "oldPassword": oldPassword,
        "newPassword": newPassword
      };

    return this.http.patch('/user/updatePassword', JSON.stringify(json));

  }

  public deleteUser(idUsuario: string) {
    return this.http.post('/user/delete', idUsuario);
  }

  public resetPassword(idUsuario: string) {
    return this.http.post('/user/resetpassword', idUsuario);
  }

  public setCheck(idProyecto: string, checkType: string, checked: boolean) {

    let json =
      {
        "idUsuario": this.getId(),
        "idProyecto": idProyecto,
        "checkType": checkType,
        "checked": checked
      };

    return this.http.post('/user/setcheck', JSON.stringify(json));

  }

  public getChecks(idProyecto: string, checks: Array<string>) {

    let json =
      {
        "idUsuario": this.getId(),
        "idProyecto": idProyecto,
        "checks": checks
      };

    return this.http.post('/user/getchecks', JSON.stringify(json));

  }

  public updateLicenseExpiry(idUsuario: string, newLicenseExpiryDate: string) {

    let json =
      {
        "idUsuario": idUsuario,
        "licenseExpiryDate": newLicenseExpiryDate
      };

    this.http.patch('/user/updateLicense', JSON.stringify(json)).subscribe(result => {
      console.log(result);
    });

  }
}
